import { render } from "./StylesView.vue?vue&type=template&id=56c9b560"
import script from "./StylesView.vue?vue&type=script&lang=js"
export * from "./StylesView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__